import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import { makeStyles } from "@material-ui/core/styles";
import { getLang } from "app/feature/constants";

const useStyles = makeStyles((theme) => ({
  pinDialogPaper: {
    borderRadius: 8,
    padding: theme.spacing(3, 2),
    minWidth: 400,
    maxWidth: 500,
    textAlign: "center",
  },
  pinDialogIcon: {
    background: "#FFF1F0",
    borderRadius: "50%",
    width: 56,
    height: 56,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: "0 auto",
    marginBottom: theme.spacing(1),
  },
  pinDialogTitle: {
    fontWeight: 600,
    fontSize: "1.25rem",
    marginBottom: theme.spacing(1),
  },
  pinDialogDesc: {
    color: theme.palette.text.secondary,
    fontSize: "1rem",
    marginBottom: theme.spacing(2),
  },
  pinDialogActions: {
    display: "flex",
    justifyContent: "center",
    gap: theme.spacing(2),
    marginTop: theme.spacing(2),
  },
  pinDialogCancel: {
    minWidth: 200,
    borderRadius: 4,
    border: "1px solid #E0E0E0",
    background: "#fff",
    color: theme.palette.text.primary,
    fontWeight: 500,
  },
  pinDialogConfirm: {
    minWidth: 200,
    borderRadius: 4,
    background: "#F04438",
    color: "#fff",
    fontWeight: 500,
    boxShadow: "0px 2px 4px rgba(58,77,84,0.08)",
    "&:hover": {
      background: "#D92D20",
    },
  },
}));

export default function PinRequiredDialog({
  open,
  onClose,
  onConfirm,
  pendingPinChange,
  lang,
}) {
  const classes = useStyles();
  const isEnable = pendingPinChange && !pendingPinChange.pinRequired;
  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{ className: classes.pinDialogPaper }}
    >
      <Box className={classes.pinDialogIcon}>
        <ErrorOutlineIcon style={{ color: "#F04438", fontSize: 32 }} />
      </Box>
      <DialogTitle disableTypography>
        <Typography className={classes.pinDialogTitle}>
          {getLang(
            lang,
            isEnable ? "label.ENABLE_PIN_REQUIRED" : "label.DISABLE_PIN_REQUIRED"
          )}
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Typography className={classes.pinDialogDesc}>
          {getLang(
            lang,
            isEnable
              ? "message.info.CONFIRM_ENABLE_PIN_REQUIRED_MESSAGE"
              : "message.info.CONFIRM_DISABLE_PIN_REQUIRED_MESSAGE"
          )}
        </Typography>
      </DialogContent>
      <DialogActions className={classes.pinDialogActions}>
        <Button
          onClick={onClose}
          className={classes.pinDialogCancel}
          variant="outlined"
        >
          {getLang(lang, "label.CANCEL")}
        </Button>
        <Button
          onClick={onConfirm}
          className={classes.pinDialogConfirm}
          variant="contained"
        >
          {getLang(lang, "label.CONFIRM")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
